// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"forum_tooltip__3_djS","forumDisabledDialog":"forum_forumDisabledDialog__3BLVe"};